firebase.initializeApp({
    apiKey: "AIzaSyAQD3cuZO_Py61beWFY4YJWizbrLXFfy-c",
    authDomain: "new-wave-ok.firebaseapp.com",
    databaseURL: "https://new-wave-ok.firebaseio.com",
    projectId: "new-wave-ok",
    storageBucket: "new-wave-ok.appspot.com",
    messagingSenderId: "34370256401"
});

const db = firebase.database();